module.exports = __webpack_public_path__ + "img/e670496.jpg";